module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/header-logo-51b5f40a2ad9d65ce305f0303b7f1843.svg";